export const requiredTopLevelSpecialtiesNames = [
    'Diagnostic Pathway – Cardiac',
    'MSK Hip & Knee Network',
    'Orthopaedic Surgery',
    'General Surgery',
    'Obstetrics & Gynaecology',
    'Ophthalmology',
    'General Medicine',
    'Cardiology',
    'Urology',
    'Ear Nose & Throat Surgery',
    'Dermatology',
    'Gastroenterology',
    'Plastic Surgery',
    'Neurology',
    'Psychiatry',
    'Paediatrics',
    'Rheumatology',
    'Neurosurgery',
    'Oral & Maxillofacial Surgery',
    'Haematology',
    'Respiratory Medicine',
    'Oncology',
    'Cardiothracic Surgery',
    'Endocrinology',
    'Neurophysiology',
    'Paediatric Surgery',
    'Sport & Exercise Medicine',
    'Nephrology (Renal Medicine)',
    'Allergy Medicine',
    'Audiology',
    'Vascular Surgery',
];



// WEBPACK FOOTER //
// ./src/client/utils/constants.js